const localStorageHelper = {
  setCid: (value) => {
    window.localStorage.setItem('cid', value);
  },

  getCid: () => window.localStorage.getItem('cid'),

  setLocale: (value) => {
    window.localStorage.setItem('locale', value);
  },

  getLocale: () => window.localStorage.getItem('locale'),

  clearTimestamp: () => {
    const locale = localStorageHelper.getLocale();
    window.localStorage.removeItem(`metadata-${locale}-timestamp`);
  },

  getTimestamp: () => {
    const locale = localStorageHelper.getLocale();
    const timestamp = window.localStorage.getItem(
      `metadata-${locale}-timestamp`,
    );

    // Fallback to 1970-01-01T00:00:00.000Z if no timestamp is found
    return timestamp ? JSON.parse(timestamp) : new Date(0).toISOString();
  },

  setTimestamp: (date = new Date()) => {
    const locale = localStorageHelper.getLocale();
    window.localStorage.setItem(
      `metadata-${locale}-timestamp`,
      JSON.stringify(date.toISOString()),
    );
  },

  setItem: (itemName, data) => {
    window.localStorage.setItem(itemName, JSON.stringify(data));
  },

  getItem: (itemName) =>
    JSON.parse(window.localStorage.getItem(itemName)) || {},

  clearNonAuthData: () => {
    // Clear cid
    window.localStorage.removeItem('cid');

    // Clear locale
    window.localStorage.removeItem('locale');

    // Clear all metadata timestamps (for all locales)
    const metadataKeys = Object.keys(window.localStorage).filter(
      (key) => key.startsWith('metadata-') && key.endsWith('-timestamp'),
    );
    metadataKeys.forEach((key) => {
      window.localStorage.removeItem(key);
    });
  },
};

export default localStorageHelper;
